import { useMediaState, type MediaPlayerInstance } from '@vidstack/react'
import { PlayIcon } from '@heroicons/react/24/solid'

interface LargePlayButtonProps {
  playerRef: React.RefObject<MediaPlayerInstance>
}

export const LargePlayButton = ({ playerRef }: LargePlayButtonProps) => {
  const isPlaying = useMediaState('playing', playerRef)

  if (isPlaying) return null

  return (
    <div
      className="absolute inset-0 flex items-center justify-center cursor-pointer bg-black/20 hover:bg-black/30 transition-colors"
      onClick={() => playerRef.current?.play()}
    >
      <div className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors">
        <PlayIcon className="w-10 h-10 text-slate-900" />
      </div>
    </div>
  )
}
